import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Feature } from '../feature'

/**
 * When a listUsers request is made, plugin attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const getUsersOnRequest = store.effects.create((feature: Feature) =>
  feature.actions.listUsers.request.observe().pipe(
    rxjs.mergeMap(action => {
      const { filters } = action.data
      // We get the list of filtered users using the API
      const userList$ = feature.api.listUsers(filters)
      // TODO: after the first response, everything else should be a follow
      // up success or follow up error
      return userList$.pipe(
        // Handles success
        rxjs.map(users =>
          feature.actions.listUsers.success.from(action).create({
            request: action.data,
            response: {
              users,
            },
          }),
        ),
        // Handles error
        rxjs.catchError(error =>
          rxjs.of(
            feature.actions.listUsers.error.from(action).create({
              error,
              request: action.data,
            }),
          ),
        ),
      )
    }),
  ),
)
